import React from "react";

export const OutlookCalendarIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="47" height="43" viewBox="0 0 63 58" fill="none">
			<g clipPath="url(#clip0_230_1102)">
				<path
					d="M62.5499 30.44C62.5533 29.9558 62.3024 29.5052 61.8885 29.252H61.8813L61.8552 29.2376L40.3369 16.5368C40.244 16.4742 40.1475 16.417 40.048 16.3655C39.2172 15.9381 38.2303 15.9381 37.3994 16.3655C37.2999 16.417 37.2035 16.4742 37.1105 16.5368L15.5922 29.2376L15.5663 29.252C14.9086 29.6598 14.707 30.522 15.116 31.1778C15.2364 31.371 15.4024 31.532 15.5995 31.6467L37.1178 44.3475C37.2111 44.4096 37.3075 44.4668 37.4067 44.5189C38.2375 44.9463 39.2245 44.9463 40.0553 44.5189C40.1545 44.4668 40.2509 44.4096 40.3442 44.3475L61.8625 31.6467C62.2924 31.3968 62.5548 30.9362 62.5499 30.44Z"
					fill="#0A2767"
				/>
				<path
					d="M18.1006 21.96H32.2219V34.8667H18.1006V21.96ZM59.6614 8.84019V2.93618C59.6953 1.46004 58.5235 0.235567 57.0431 0.200195H20.3983C18.9179 0.235567 17.7461 1.46004 17.78 2.93618V8.84019L39.4428 14.6002L59.6614 8.84019Z"
					fill="#0364B8"
				/>
				<path d="M17.7793 8.84033H32.2211V21.8003H17.7793V8.84033Z" fill="#0078D4" />
				<path
					d="M46.6626 8.84033H32.2207V21.8003L46.6626 34.7603H59.6602V21.8003L46.6626 8.84033Z"
					fill="#28A8EA"
				/>
				<path d="M32.2207 21.8003H46.6625V34.7603H32.2207V21.8003Z" fill="#0078D4" />
				<path d="M32.2207 34.7603H46.6625V47.7202H32.2207V34.7603Z" fill="#0364B8" />
				<path d="M18.0996 34.8667H32.2209V46.5998H18.0996V34.8667Z" fill="#14447D" />
				<path d="M46.6621 34.7603H59.6598V47.7202H46.6621V34.7603Z" fill="#0078D4" />
				<path
					d="M61.8873 31.5675L61.8599 31.5819L40.3415 43.649C40.2476 43.7066 40.1523 43.7614 40.0526 43.8103C39.6871 43.9839 39.2902 44.0818 38.8858 44.0983L37.7102 43.4129C37.6108 43.3632 37.5144 43.3079 37.4213 43.2473L15.6142 30.8374H15.604L14.8906 30.4399V54.8681C14.9017 56.4979 16.2354 57.8103 17.87 57.7999H59.6156C59.6401 57.7999 59.6618 57.7884 59.6878 57.7884C60.033 57.7664 60.3734 57.6956 60.6987 57.5782C60.8393 57.5188 60.975 57.4485 61.1045 57.3679C61.2013 57.3132 61.3674 57.1937 61.3674 57.1937C62.1072 56.6479 62.5451 55.7858 62.5487 54.8681V30.4399C62.5482 30.9072 62.2955 31.338 61.8873 31.5675Z"
					fill="url(#paint0_linear_230_1102)"
				/>
				<path
					opacity="0.5"
					d="M61.3942 30.3435V31.8411L38.8938 47.2879L15.5991 30.8475C15.5991 30.8395 15.5926 30.833 15.5846 30.833L13.4473 29.5515V28.4714L14.3282 28.457L16.1912 29.5226L16.2345 29.537L16.3934 29.6379C16.3934 29.6379 38.2872 42.0938 38.345 42.1226L39.1826 42.6122C39.2548 42.5834 39.327 42.5546 39.4137 42.5258C39.457 42.497 61.1486 30.329 61.1486 30.329L61.3942 30.3435Z"
					fill="#0A2767"
				/>
				<path
					d="M61.8873 31.5675L61.8598 31.5833L40.3415 43.6505C40.2476 43.7081 40.1523 43.7628 40.0526 43.8117C39.2169 44.2188 38.2396 44.2188 37.404 43.8117C37.305 43.7629 37.2086 43.709 37.1151 43.6505L15.5968 31.5833L15.5708 31.5675C15.1554 31.3429 14.8949 30.9111 14.8906 30.4399V54.8681C14.901 56.4976 16.2342 57.8102 17.8684 57.7999C17.8684 57.7999 17.8685 57.7999 17.8685 57.7999H59.5708C61.2051 57.8103 62.5383 56.4977 62.5487 54.8682C62.5487 54.8682 62.5487 54.8682 62.5487 54.8681V30.4399C62.5482 30.9072 62.2955 31.338 61.8873 31.5675Z"
					fill="#1490DF"
				/>
				<path
					opacity="0.1"
					d="M40.6562 43.4722L40.3341 43.6522C40.2408 43.7114 40.1444 43.7658 40.0453 43.8149C39.6905 43.9885 39.3046 44.0904 38.9102 44.1144L47.0972 53.7682L61.3788 57.1997C61.7701 56.9049 62.0814 56.5173 62.2843 56.0722L40.6562 43.4722Z"
					fill="#1D1F23"
				/>
				<path
					opacity="0.05"
					d="M42.1148 42.6543L40.3341 43.6522C40.2408 43.7115 40.1444 43.7658 40.0453 43.8149C39.6905 43.9886 39.3046 44.0904 38.9102 44.1144L42.7459 54.6596L61.3831 57.1954C62.1173 56.6457 62.5496 55.7838 62.55 54.8683V54.553L42.1148 42.6543Z"
					fill="#1D1F23"
				/>
				<path
					d="M17.909 57.7999H59.5665C60.2075 57.8032 60.8327 57.6013 61.35 57.2239L37.7087 43.4158C37.6094 43.3661 37.5129 43.3108 37.4199 43.2502L15.6127 30.8403H15.6026L14.8906 30.4399V54.7846C14.889 56.4483 16.2403 57.7983 17.909 57.7999Z"
					fill="#28A8EA"
				/>
				<path
					opacity="0.1"
					d="M35.1092 14.3597V45.0749C35.1066 46.1518 34.4499 47.1198 33.4484 47.5229C33.1382 47.6558 32.804 47.7245 32.4663 47.7245H14.8906V13.1602H17.779V11.7202H32.4664C33.9253 11.7257 35.1061 12.905 35.1092 14.3597Z"
					fill="#1D1F23"
				/>
				<path
					opacity="0.2"
					d="M33.665 15.7998V46.5149C33.6687 46.8628 33.5947 47.2071 33.4484 47.5229C33.0473 48.5086 32.089 49.1553 31.0222 49.1602H14.8906V13.1603H31.0222C31.4412 13.1561 31.8542 13.2603 32.2208 13.4627C33.1061 13.9074 33.6647 14.8114 33.665 15.7998Z"
					fill="#1D1F23"
				/>
				<path
					opacity="0.2"
					d="M33.665 15.7998V43.635C33.658 45.0891 32.4805 46.2676 31.0222 46.2802H14.8906V13.1603H31.0222C31.4412 13.1561 31.8542 13.2603 32.2208 13.4627C33.1061 13.9074 33.6647 14.8114 33.665 15.7998Z"
					fill="#1D1F23"
				/>
				<path
					opacity="0.2"
					d="M32.2208 15.7997V43.6348C32.2193 45.0912 31.0386 46.273 29.578 46.2801H14.8906V13.1602H29.578C31.0384 13.1609 32.2216 14.3421 32.2208 15.7982C32.2208 15.7987 32.2208 15.7992 32.2208 15.7997Z"
					fill="#1D1F23"
				/>
				<path
					d="M3.0964 13.1602H29.5741C31.0361 13.1602 32.2213 14.3419 32.2213 15.7997V42.2006C32.2213 43.6584 31.0361 44.8401 29.5741 44.8401H3.0964C1.63439 44.8401 0.449219 43.6583 0.449219 42.2006V15.7997C0.449219 14.3419 1.63442 13.1602 3.0964 13.1602Z"
					fill="url(#paint1_linear_230_1102)"
				/>
				<path
					d="M8.72384 24.2308C9.37629 22.8447 10.4294 21.6848 11.748 20.9001C13.2082 20.0665 14.8708 19.6509 16.5528 19.6991C18.1117 19.6654 19.6499 20.0594 20.9994 20.8381C22.2683 21.5926 23.2902 22.6981 23.9412 24.0205C24.6502 25.4776 25.0035 27.0812 24.9724 28.7005C25.0068 30.3927 24.6432 32.0695 23.9109 33.5965C23.2444 34.9661 22.1901 36.111 20.8781 36.8897C19.4765 37.6923 17.8812 38.0967 16.2654 38.059C14.6732 38.0974 13.1011 37.6989 11.7205 36.907C10.4407 36.1515 9.40593 35.0448 8.73975 33.7189C8.0266 32.2828 7.66907 30.6972 7.69705 29.095C7.66734 27.4172 8.01836 25.7543 8.72384 24.2308ZM11.9473 32.0499C12.2951 32.9262 12.885 33.6861 13.6485 34.2416C14.4262 34.7836 15.3573 35.0631 16.3058 35.0394C17.3159 35.0792 18.3115 34.7901 19.1422 34.2157C19.896 33.6619 20.4704 32.8999 20.7943 32.024C21.1564 31.0458 21.3351 30.0095 21.3215 28.9669C21.3326 27.9143 21.1647 26.8675 20.8246 25.8709C20.5243 24.9712 19.9684 24.1778 19.2245 23.5871C18.4146 22.9855 17.4217 22.6804 16.4127 22.7231C15.4437 22.698 14.4916 22.9798 13.6933 23.528C12.9169 24.0859 12.3158 24.8525 11.9603 25.7384C11.1716 27.769 11.1675 30.0193 11.9487 32.0528L11.9473 32.0499Z"
					fill="white"
				/>
				<path d="M46.6621 8.84033H59.6598V21.8003H46.6621V8.84033Z" fill="#50D9FF" />
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_230_1102"
					x1="38.7197"
					y1="30.4399"
					x2="38.7197"
					y2="57.8"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#35B8F1" />
					<stop offset="1" stopColor="#28A8EA" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_230_1102"
					x1="5.96867"
					y1="11.0977"
					x2="26.6117"
					y2="46.9545"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#1784D9" />
					<stop offset="0.5" stopColor="#107AD5" />
					<stop offset="1" stopColor="#0A63C9" />
				</linearGradient>
				<clipPath id="clip0_230_1102">
					<rect width="62.1" height="57.6" fill="white" transform="translate(0.449219 0.200195)" />
				</clipPath>
			</defs>
		</svg>
	);
};
